import React, { FC, useEffect, useRef, useState } from "react";
import { Modal } from "antd";
import closeIcon from "../../../../assets/icons/close.svg";
import "./subjectForm.scss";
import ToggleSwitch from "../../ToggleSwitch";
import UploadLogo from "../../UploadLogo";
import { Formik, Form, Field } from "formik";
import ButtonComponent from "../../ButtonComponent";
import InputField from "../../InputField";
import { serialize } from "serializr";
import {
  ClassRoomSubjectModel,
  SubjectModel,
} from "../../../../models/CourseModels/SubjectModel/subject.model";
import SubjectService from "../../../../services/CourseServices/SubjectService/subject.service";
import DropdownField from "../../DropdownField";
import { convertJSONToFormData } from "../../../utils/converJsonToFormData";
import CommonService from "../../../../services/CommonService/common.service";
import { RouteComponentProps, withRouter } from "react-router";
import { ExamService } from "../../../../services/ExamService/exam.service";
import { ExamSubjectsService } from "../../../../services/ExamService/SubjectService/subject.service";
import { SketchPicker } from "react-color";
import { ClassFormValidation } from "../courseValidation";
interface SubjectFormProps extends RouteComponentProps {
  title: string;
  visible: boolean;
  setVisible: Function;
  data?: any;
  refreshList: Function;
  currentPageNumber: number;
  classroomId?: number;
  examId?: any;
}

const SubjectForm: FC<SubjectFormProps> = (props) => {
  const {
    title,
    visible,
    setVisible,
    data,
    refreshList,
    currentPageNumber,
    classroomId,
    examId,
  } = props;

  const formRef = useRef<any>();

  useEffect(() => {
    console.log(data);
    setInitialValues({
      name: data?.name,
      subjectId: data?.id,
      subjectStreamId: data?.subjectStream?.id,
      amount: data?.amountPaise / 100 || null,
      isActive: data?.isActive ? data.isActive : false,
      displayPicture: null,
      colorCode: data?.subject?.colorCode || "",
    });
    setLogoUrl(data?.subject?.displayPictureUrl || "");
    CommonService.fetchMeta(
      "subject_streams",
      (options: any) => {
        setSubjectStreams(options);
      },
      () => {},
      () => {}
    ).then();
    SubjectService.getSubjectsList(
      "?per_page=200&page=1",
      (subjects: any) => {
        setSubjectMeta([
          ...subjects.map((subject: any) => ({
            label: subject.name,
            value: parseInt(subject.id),
            displayPictureUrl: subject.displayPictureUrl,
          })),
        ]);
      },
      () => {},
      () => {}
    ).then();
  }, [data]);

  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<any>({});
  const [subjectStreams, setSubjectStreams] = useState<any>([]);
  const [subjectMeta, setSubjectMeta] = useState<any>([]);
  const [logoUrl, setLogoUrl] = useState<string>("");

  const handleClose = () => {
    setVisible(false);
    formRef.current.resetForm(initialValues);
  };

  const createClassroomSubject = (classroomSubjectJsonData: any) => {
    console.log(classroomSubjectJsonData);
    SubjectService.createClassroomSubject(
      classroomSubjectJsonData,
      () => {
        if (refreshList) refreshList(currentPageNumber);
        setVisible(false);
        formRef.current.resetForm(initialValues);
      },
      () => {},
      () => {
        setButtonLoading(false);
      }
    ).then();
  };

  const updateClassroomSubject = (classroomSubjectJsonData: any) => {
    console.log(classroomSubjectJsonData);
    SubjectService.updateClassroomSubject(
      data.id,
      classroomSubjectJsonData,
      () => {
        if (refreshList) refreshList(currentPageNumber);
        setVisible(false);
        formRef.current.resetForm(initialValues);
      },
      () => {},
      () => {
        setButtonLoading(false);
      }
    ).then();
  };

  const createExamSubject = (formData: any) => {
    ExamSubjectsService.createNewExamSubject(
      formData,
      (response: any) => {
        if (refreshList) refreshList(currentPageNumber);
        setVisible(false);
        formRef.current.resetForm(initialValues);
        setButtonLoading(false);
      },
      (error: any) => {}
    );
  };

  const updateExamSubject = (formData: any) => {
    console.log(formData);
    ExamSubjectsService.updateExamSubject(
      data.id,
      formData,
      (response: any) => {
        if (refreshList) refreshList(currentPageNumber);
        setVisible(false);
        formRef.current.resetForm(initialValues);
        setButtonLoading(false);
      },
      (error: any) => {}
    );
  };

  const handleSubmit = (values: any) => {
    setButtonLoading(true);
    let subjectFormData;
    let classroomSubjectData = serialize(ClassRoomSubjectModel, values);
    classroomSubjectData.class_room_id = classroomId;
    if (
      isNaN(classroomSubjectData.subject_name) ||
      values?.displayPicture ||
      values?.colorCode
    ) {
      let subjectData: any = {};
      if (isNaN(classroomSubjectData.subject_name))
        subjectData.name = classroomSubjectData.subject_name;
      if (values?.displayPicture)
        subjectData.display_picture = values?.displayPicture;
      if (values?.colorCode) subjectData.color_code = values?.colorCode;
      let jsonData = { subject: subjectData };
      console.log(jsonData);
      subjectFormData = convertJSONToFormData(jsonData);
    }

    let classroomSubjectJsonData = { class_room_subject: classroomSubjectData };
    if (!data && isNaN(classroomSubjectData.subject_name)) {
      //new subject
      SubjectService.createSubject(
        subjectFormData,
        (subject: any) => {
          classroomSubjectJsonData.class_room_subject.subject_id = subject.id;
          //create classroom subject with new subject
          if (!data) createClassroomSubject(classroomSubjectJsonData);
          //update classroom subject with new subject
          else updateClassroomSubject(classroomSubjectJsonData);
        },
        () => {},
        () => {
          setButtonLoading(false);
        }
      ).then();
    } else if (
      isNaN(classroomSubjectData.subject_name) &&
      (values?.displayPicture || values?.colorCode)
    ) {
      SubjectService.updateSubject(
        data?.subject?.id,
        subjectFormData,
        (subject: any) => {
          console.log(subject);
          classroomSubjectJsonData.class_room_subject.subject_id = subject.id;
          //create classroom subject with updated subject
          if (!data) createClassroomSubject(classroomSubjectJsonData);
          //update classroom subject with updated subject
          else updateClassroomSubject(classroomSubjectJsonData);
        },
        () => {},
        () => {
          setButtonLoading(false);
        }
      ).then();
    } else {
      classroomSubjectJsonData.class_room_subject.subject_id =
        classroomSubjectData.subject_name;
      //create classroom subject with existing subject
      if (!data) createClassroomSubject(classroomSubjectJsonData);
      //update classroom subject with existing subject
      else updateClassroomSubject(classroomSubjectJsonData);
    }
  };
  const handleSubmitExam = (values: any) => {
    setButtonLoading(true);
    let subjectFormData;
    let examSubjectData = serialize(ClassRoomSubjectModel, values);
    examSubjectData.exam_id = examId;

    if (
      isNaN(examSubjectData.subject_name) ||
      values?.displayPicture ||
      values?.colorCode
    ) {
      let subjectData: any = {};
      if (isNaN(examSubjectData.subject_name))
        subjectData.name = examSubjectData.subject_name;
      if (values?.displayPicture)
        subjectData.display_picture = values?.displayPicture;
      if (values?.colorCode) subjectData.color_code = values?.colorCode;
      let jsonData = { subject: subjectData };
      subjectFormData = convertJSONToFormData(jsonData);
    }

    let examSubjectJsonData = { exam_subject: examSubjectData };
    if (!data && isNaN(examSubjectData.subject_name)) {
      //new subject
      console.log(subjectFormData);
      SubjectService.createSubject(
        subjectFormData,
        (subject: any) => {
          console.log(subject);
          examSubjectJsonData.exam_subject.subject_id = subject.id;
          //create classroom subject with new subject
          if (!data) createExamSubject(examSubjectJsonData);
          //update classroom subject with new subject
          else updateExamSubject(examSubjectJsonData);
        },
        () => {},
        () => {
          setButtonLoading(false);
        }
      ).then();
    } else if (
      isNaN(examSubjectData.subject_name) &&
      (values?.displayPicture || values?.colorCode)
    ) {
      SubjectService.updateSubject(
        data?.subject?.id,
        subjectFormData,
        (subject: any) => {
          examSubjectJsonData.exam_subject.subject_id = subject.id;
          //create classroom subject with updated subject
          if (!data) createExamSubject(examSubjectJsonData);
          //update classroom subject with updated subject
          else updateExamSubject(examSubjectJsonData);
        },
        () => {},
        () => {
          setButtonLoading(false);
        }
      ).then();
    } else {
      examSubjectJsonData.exam_subject.subject_id =
        examSubjectData.subject_name;
      //create classroom subject with existing subject
      if (!data) createExamSubject(examSubjectJsonData);
      //update classroom subject with existing subject
      else updateExamSubject(examSubjectJsonData);
    }
  };

  return (
    <Modal
      title={null}
      centered
      visible={visible}
      onCancel={handleClose}
      footer={null}
      className="board-form__modal"
      closeIcon={<img src={closeIcon} alt="" />}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={
          props.location.pathname.includes("exams")
            ? handleSubmitExam
            : handleSubmit
        }
        enableReinitialize
        validationSchema={ClassFormValidation}
        innerRef={formRef}
      >
        {({ setFieldValue, values, resetForm }) => {
          return (
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <div className="board-form__header">
                <div className="board-form__title">{title}</div>
                <div className="board-form__toggle">
                  <Field name="isActive" as="switch">
                    <ToggleSwitch
                      checked={values.isActive}
                      handleChange={() => {
                        setFieldValue("isActive", !values.isActive);
                      }}
                    />
                  </Field>
                </div>
              </div>

              <Field name="displayPicture" as="file-upload">
                <UploadLogo
                  logoUrl={
                    values?.displayPicture ? values?.displayPicture : logoUrl
                  }
                  setFile={setFieldValue}
                />
              </Field>

              <div className="board-form__input">
                <div className="board-form__label">Color of subject</div>
                <SketchPicker
                  color={values?.colorCode}
                  onChangeComplete={(color) =>
                    setFieldValue("colorCode", color.hex)
                  }
                />
              </div>

              <div className="board-form__input">
                <div className="board-form__label">Name of subject *</div>
                <DropdownField
                  name="name"
                  placeholder="Type subject name"
                  mode="tags"
                  options={subjectMeta}
                  showSearch={true}
                  value={values?.name}
                  onChange={(value: any) => {
                    console.log(subjectMeta, value);
                    setLogoUrl(
                      subjectMeta.filter(
                        (o: any) => o.value === value[value.length - 1]
                      )[0]?.displayPictureUrl
                    );
                    setFieldValue("name", value[value.length - 1]);
                  }}
                  optionFilterProp="label"
                />
              </div>

              <div className="board-form__input">
                <div className="board-form__label">Subject stream</div>
                <DropdownField
                  name="subjectStreamId"
                  placeholder="Select subject stream"
                  options={subjectStreams}
                  showSearch={true}
                  value={values?.subjectStreamId}
                  onChange={(value: any) => {
                    setFieldValue("subjectStreamId", value);
                  }}
                  optionFilterProp="label"
                />
              </div>

              <div className="board-form__input">
                <div className="board-form__label">Subscription cost *</div>
                <InputField
                  type="text"
                  name="amount"
                  placeholder="Enter cost"
                  prefix="₹"
                />
              </div>

              <div className="board-form__action">
                <div
                  className="board-form__button"
                  onClick={() => {
                    handleClose();
                    resetForm({});
                  }}
                >
                  <ButtonComponent buttonContent="Cancel" type="text" />
                </div>
                <div className="board-form__button">
                  <ButtonComponent
                    buttonContent={data ? "Update" : "Create"}
                    type="primary"
                    htmlType="submit"
                    loading={buttonLoading}
                  />
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default withRouter(SubjectForm);
